import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DashboardWidgetComponent, DashboardWidgetInstance } from '../../../../components/JBM/Dashboard/models/dashboard-widget.types';
import { ProjectsService } from '../../../projects/data/projects.service';

@Component({
  selector: 'widget-production',
  templateUrl: './widget-production.component.html',
  styleUrls: ['./widget-production.component.scss']
})
export class WidgetProductionComponent implements DashboardWidgetComponent, OnChanges {
  title: string = 'Productie vandaag';
  icon: string = 'fa-industry';
  productionData: any = null;
  plantId: number = 0;

  @Input() config!: DashboardWidgetInstance;

  constructor(private ProjectsService: ProjectsService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.config)
      this.plantId = Number(this.config?.settings?.plantId ?? 0);

    this.ProjectsService.getDashboardDayProduction(this.plantId).subscribe(
      (data: any) => this.productionData = data.data,
      (error: any) => console.error(error)
    );
  }
}
